import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { withRouter } from 'react-router-dom';

import {
    fetchSocialActionsByObjective,
    fetchSocialCalloutsByObjective,
    fetchSocialCampaignsByObjective,
    fetchSocialDataByObjective
} from 'services/social/duck';

import { SocialObjectiveDashboardComponent } from 'containers/dashboards/DashboardBaseComponent';
import VideoViewsExpandModule from 'components/organisms/social/VideoViewsExpandModule';

class VideoViewsExpandedContainer extends SocialObjectiveDashboardComponent {
    constructor(props) {
        super(props, 'VIDEO_VIEWS');
    }

    makeRequestsForData() {
        const entityId = this.getCurrentEntityId();
        const objective = this.getCurrentObjective();
        const payload = this.createPayload(entityId, objective);

        this.props.fetchSocialActionsByObjective(payload);
        this.props.fetchSocialDataByObjective(payload);
        this.props.fetchSocialCalloutsByObjective(payload);
        this.props.fetchSocialCampaignsByObjective(payload);
    }

    render() {
        const { hide, showConversionRevenue, showSemCpconv } = this.props;
        return (
            !hide ?
                <VideoViewsExpandModule module={this.props.module}
                    xAxisLabel={this.props.xAxisLabel}
                    backfillBuckets={this.props.backfillBuckets}
                    layer={this.props.layer}
                    layerTwo={this.props.layerTwo}
                    showSemCpconv={showSemCpconv}
                    showConversionRevenue={showConversionRevenue}
                    entityMeta={this.props.entityMeta}
                    entityObjective={this.props.entityObjective}
                    entityObjectiveLabelCode={this.props.entityObjectiveLabelCode}
                /> : null
        );
    }
}

const mapStateToProps = state => ({
    entityMeta: state.entities.meta,
    module: state.social.facebook.objectives.VIDEO_VIEWS,
    layerTwo: state.layerTwo,
    selectedTimeRange: state.config.selectedTimeRange,
    xAxisLabel: get(state, 'config.timeBuckets.config.xAxisLabel', 'Date'),
    backfillBuckets: get(state, 'config.timeBuckets.config.buckets', []),
    showSemCpconv: get(state, 'entities.meta.meta.showSemCpconv', false),
    showConversionRevenue: get(state, 'entities.meta.meta.showConversionRevenue', false),
    entityObjective: get(state, 'entities.meta.meta.programmaticObjective.global', 'ecpa'),
    entityObjectiveLabelCode: get(state, 'entities.meta.meta.programmaticObjective.labelCode', null),
});

export default withRouter(
    connect(mapStateToProps, {
        fetchSocialActionsByObjective,
        fetchSocialCalloutsByObjective,
        fetchSocialCampaignsByObjective,
        fetchSocialDataByObjective,
    })(VideoViewsExpandedContainer));



// WEBPACK FOOTER //
// ./src/containers/dashboards/social/VideoViewsExpandContainer.js